import checkout from "./form6";

const {
  formField6: {
    endow,
    departmentLevel,
    subordinateToTheDepartment,
    project,
    city,
    district,
    commune
  },
} = checkout;

const initialValues6 = {
  [endow.name]: "",
  [departmentLevel.name]: "",
  [subordinateToTheDepartment.name]: "",
  [project.name]: false,
  [city.name]: "",
  [district.name]: "",
  [commune.name]: "",
};

export default initialValues6;
